import React from 'react';
import {Collapse, FormControlLabel, FormHelperText, Radio, TextField,} from '@material-ui/core';

import {withStyles} from "@material-ui/core/styles";

const styles = {
  designees:{
    display:"flex",
    flexDirection: "column",
    flexWrap: "wrap",
    gap: '1em'
  },
  info:{
    fontSize: '0.85rem',
    fontWeight: '300',
  },
  row:{
    display:"flex",
    flexWrap:"wrap",
    alignItems: 'center',
    gap: '1em',
    width: '100%'
  },
  input:{
    width: '100%',
    maxWidth: '20em',
    minWidth: '10em'
  },
};

function DesigneesForm(props) {
  const { classes } = props;
  const {registrationInProgress,
    designee1, setDesignee1, relationship1, setRelationship1,
    designee2, setDesignee2, relationship2, setRelationship2,
    designee3, setDesignee3, relationship3, setRelationship3,
    doNotDisclose, setDoNotDisclose } = props;

  return (
    <>
      <div>
        <FormControlLabel
          id="assignDesignees"
          control={
            <Radio
              checked={!doNotDisclose}
              onChange={() => setDoNotDisclose(false)}
              value="designees"
              name="doNotDisclose"
              inputProps={{ 'aria-label': 'Assign Designees' }}
            />
        }
          label={<FormHelperText variant="standard">Designate access in the event of death or incapacitation</FormHelperText>}
        />
      </div>
      <Collapse in={!doNotDisclose}>
        <div className={classes.designees}>
          <div className={classes.info}>
            In the event of my legal death or physical/mental incapacitation: I agree to and permit the LifeNaut staff to provide access to my LifeNaut account to the following designees
          </div>
          <div className={classes.row}>
            <TextField
              id='designee1' label='Name 1'
              margin='none' size='small' variant='outlined' className={classes.input}
              value={designee1}
              onChange={event => {setDesignee1(event.target.value)}}
              disabled={registrationInProgress}
            />
            <TextField
              id='relationship1' label='Relationship 1'
              margin='none' size='small' variant='outlined' className={classes.input}
              value={relationship1}
              onChange={event => {setRelationship1(event.target.value)}}
              disabled={registrationInProgress}
            />
          </div>
          <div className={classes.row}>
            <TextField
              id='designee2' label='Name 2'
              margin='none' size='small' variant='outlined' className={classes.input}
              value={designee2}
              onChange={event => {setDesignee2(event.target.value)}}
              disabled={registrationInProgress}
            />
            <TextField
              id='relationship2' label='Relationship 2'
              margin='none' size='small' variant='outlined' className={classes.input}
              value={relationship2}
              onChange={event => {setRelationship2(event.target.value)}}
              disabled={registrationInProgress}
            />
          </div>
          <div className={classes.row}>
            <TextField
              id='designee3' label='Name 3'
              margin='none' size='small' variant='outlined' className={classes.input}
              value={designee3}
              onChange={event => {setDesignee3(event.target.value)}}
              disabled={registrationInProgress}
            />
            <TextField
              id='relationship3' label='Relationship 3'
              margin='none' size='small' variant='outlined' className={classes.input}
              value={relationship3}
              onChange={event => {setRelationship3(event.target.value)}}
              disabled={registrationInProgress}
            />
          </div>
        </div>
      </Collapse>
      <div>
        <FormControlLabel
          id="doNotDisclose"
          control={
            <Radio
              checked={doNotDisclose}
              onClick={() => { setDoNotDisclose(true)}}
              value="doNotDisclose"
              name="doNotDisclose"
              inputProps={{ 'aria-label': 'Do Not Disclose' }}
            />
          }
          label={<FormHelperText variant="standard">Selecting this option prohibits (forbids) TMF from disclosing the contents of or access to User's Mindfile to any individual or fiduciary</FormHelperText>}
        />
      </div>
    </>
  );
}
export default withStyles(styles)(DesigneesForm);